export default __webpack_public_path__ + "static/media/Band of Bloodthirst.f3a33b43.jpg";